import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ServiceTypeList from "../pages/ServiceType/ServiceTypeList";
import CreateServiceType from "../pages/ServiceType/CreateServiceType";
import EditServiceType from "../pages/ServiceType/EditServiceType";
//@ts-ignore
import {PermissionRequired,AccessControl,} from "@careinfo/permission-required";

export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path="/" element={<ServiceTypeList />} />
          <Route path="/service-type" element={<ServiceTypeList />} />
          <Route
            path="/create"
            element={
              <AccessControl
                children={<CreateServiceType />}
                allowedPermissions={["can_update_setting"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path="/edit/:id"
            element={
              <AccessControl
                children={<EditServiceType />}
                allowedPermissions={["can_update_setting"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
